import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';
import AiUsage from './AiUsage';
import AiConversations from './AiConversations';
import AiCorrections from './AiCorrections';
import { getBrandColor } from '../../utils/colorUtils';
import { isTcAdmin } from '../../utils/roleUtils';
import { AI_CORRECTIONS_ENABLED } from '../../config/aiFeatures';

const AiUsageTabs = ({ currentUser }) => {
  const brandColor = getBrandColor();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabs = [
    { key: 'overview', label: 'AI Overview' },
    { key: 'conversations', label: 'AI Conversations' },
    ...(AI_CORRECTIONS_ENABLED && isTcAdmin(currentUser?.role) ? [{ key: 'corrections', label: 'AI Corrections' }] : []),
  ];
  const requested = searchParams.get('tab');
  const tab = tabs.some(t => t.key === requested) ? requested : 'overview';

  return (
    <Box>
      <Tabs
        value={tab}
        onChange={(e, value) => setSearchParams(value === 'overview' ? {} : { tab: value }, { replace: true })}
        sx={{
          mb: 2, borderBottom: 1, borderColor: 'divider',
          '& .MuiTab-root': { textTransform: 'none', fontSize: '0.85rem', minHeight: 44 },
          '& .Mui-selected': { color: `${brandColor} !important` },
          '& .MuiTabs-indicator': { bgcolor: brandColor },
        }}
      >
        {tabs.map(t => <Tab key={t.key} value={t.key} label={t.label} />)}
      </Tabs>

      {tab === 'overview' && <AiUsage currentUser={currentUser} />}
      {tab === 'conversations' && <AiConversations currentUser={currentUser} />}
      {tab === 'corrections' && <AiCorrections currentUser={currentUser} />}
    </Box>
  );
};

export default AiUsageTabs;
